import { ReactElement, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import packageJson from '../../../package.json';
import { APP_NAME } from '../../AppConstants';
import ControlantIcon from '../../assets/controlant-logo-white-blue.png';
import { dayjs } from '../../helpers/DateTime';
import { User } from '../../types/User';

import '../../styles/components/Header.less';

interface Props {
    currentUser?: User;
    environment: string | undefined;
}

const Header = ({ currentUser, environment }: Props): ReactElement => {
    const [time, setTime] = useState<string>('');

    useEffect(() => {
        setTime(dayjs().format('MMMM Do YYYY, HH:mm'));
        const timeInterval = setInterval(() => {
            setTime(dayjs().format('MMMM Do YYYY, HH:mm'));
        }, 10000);

        return function cleanUp() {
            clearInterval(timeInterval);
        };
    }, []);

    return (
        <div className="app-header-container">
            <div className="logo-container">
                <img role="heading" className="controlant-logo" src={ControlantIcon} alt="Controlant" />
            </div>
            <div className="user-info" data-testid="user-info">
                {time && (
                    <span>
                        <FontAwesomeIcon icon="clock" className="margin-right" title="Time" />
                        {time}
                    </span>
                )}
                {currentUser && (
                    <span>
                        <FontAwesomeIcon icon="user" className="margin-right" title="Username" />
                        {currentUser.username}
                    </span>
                )}
                {currentUser && (
                    <span>
                        <FontAwesomeIcon icon="map-marker-check" className="margin-right" title="Location Name" />
                        {currentUser.locationName ?? 'N/A'}
                    </span>
                )}
                {environment && (
                    <span>
                        <FontAwesomeIcon icon="info-circle" className="margin-right" title="Version Number" />
                        {['LIVE', 'UAT', 'STABLE'].includes(environment)
                            ? packageJson.version
                            : packageJson.branch_name_and_cha}
                    </span>
                )}
            </div>
            <div data-testid="app-name" className="app-name-container">
                <span>{APP_NAME}</span>
            </div>
        </div>
    );
};

export default Header;
